import { render, staticRenderFns } from "./Imgupload.vue?vue&type=template&id=7322fc2a&scoped=true"
import script from "./Imgupload.vue?vue&type=script&lang=js"
export * from "./Imgupload.vue?vue&type=script&lang=js"
import style0 from "./Imgupload.vue?vue&type=style&index=0&id=7322fc2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7322fc2a",
  null
  
)

export default component.exports